import { Box, Typography, keyframes } from "@mui/material";

const marquee = keyframes`
  100% {
    transform: translateX(
      calc((var(--items) * (var(--carousel-item-width) + var(--carousel-item-gap))) * -1)
    );
  }
`;

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const DesktopTeamComponent = ({ cardData }) => {
  const items = cardData.length;

  return (
    <Box
      sx={{
        // border: "1px solid red",
        "--items": items,
        "--carousel-duration": {
          xs: "40s",
          sm: "30s",
        },
        "--carousel-width": "min(80vw, 1200px)",
        "--carousel-item-width": "280px",
        "--carousel-item-height": "450px",
        "--carousel-item-gap": "2rem",
        position: "relative",
        width: "var(--carousel-width)",
        height: "var(--carousel-item-height)",
        overflow: "hidden",
        maskImage:
          "linear-gradient(to right, transparent, black 10% 90%, transparent)",
        "&:hover .carousel-item": {
          animationPlayState: "paused",
        },
        mb: 5
      }}
    >
      {cardData.map((card, index) => (
        <Box
          key={card.key || index}
          className="carousel-item"
          sx={{
            position: "absolute",
            top: 0,
            left: "calc(100% + var(--carousel-item-gap))",
            width: "var(--carousel-item-width)",
            height: "var(--carousel-item-height)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            py: 5,
            borderRadius: "10px",
            background: "rgba(255, 255, 255, 0.8)",
            // backdropFilter: "blur(5px)",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.10)",
            color: "#314158",
            willChange: "transform",
            animation: `${fadeInUp} 0.8s ease ${
              index * 0.2
            }s both, ${marquee} var(--carousel-duration) linear infinite`,
            animationDelay: `${
              index * 0.2
            }s, calc((var(--carousel-duration) / var(--items)) * ${index} * -1)`,
          }}
        >
          <Box
            component="img"
            src={card.image}
            alt={card.name}
            sx={{
              width: "150px",
              height: "150px",
              objectFit: "contain",
              borderRadius: "50%",
              // mt: 2,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              // border: "1px solid red",
              px: 2,
              mt: 1,
              textAlign: "center",
              color: "#333",
              // color: "rgb(5 78 146)",
              fontSize: "20px",
              fontWeight: "550",
            }}
          >
            {card.name}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              // border: "1px solid red",
              px: 2,
              color: "#333",
              fontSize: "16px",
              textAlign: "center",
              mt: 0.5,
            }}
          >
            {card.position}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              // border: "1px solid red",
              px: 2,
              fontSize: "14px",
              color: "text.secondary",
              mt: 1,
              pl: 4,
              lineHeight: 1.4,
              textAlign: "left",
            }}
          >
            {card.feedback}
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: "2.5rem",
              mt: 2,
              justifyContent: "center",
              opacity: 0.9,
            }}
          >
            {card.social?.twitter && (
              <Box
                component="img"
                src={card.social.twitter}
                alt="Twitter"
                sx={{
                  width: "24px",
                  height: "24px",
                  objectFit: "contain",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "scale(1.2)" },
                }}
              />
            )}
            {card.social?.linkedin && (
              <Box
                component="img"
                src={card.social.linkedin}
                alt="LinkedIn"
                sx={{
                  width: "24px",
                  height: "24px",
                  objectFit: "contain",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "scale(1.2)" },
                }}
              />
            )}
        
            {card.social?.instagram && (
              <Box
                component="img"
                src={card.social.instagram}
                alt="Instagram"
                sx={{
                  width: "24px",
                  height: "24px",
                  objectFit: "contain",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "scale(1.2)" },
                }}
              />
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default DesktopTeamComponent;




